<template>
  <div class="container">
    <img class="casestudy-img" :src="props.icon" alt="SVG icon depicting theme related to...">
    
    <h5 class="casestudy-title"> {{ props.title }} </h5>
    <p class="casestudy-text"> {{ props.text }}</p>

    <router-link class="casestudy-button" :to="`/casestudy/${props.route}`">
      READ MORE
    </router-link>
  </div>  
</template>

<script setup>
const props = defineProps({
  title: String,
  text: String,
  icon: String,
  route: String
})

</script>

<style scoped>

.container {
  height: 392px;
  width: 271px;
  background-color: #070923;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.casestudy-img {
  width: 159px;
  height: 159px;
}

.casestudy-title {
  width: 223px;
  max-height: 40px;
  font-size: 18px;
  color: #00FFBA;
  line-height: 25px;
  margin-top: -5px;

}

.casestudy-text {
  width: 223px;
  font-size: 12px;
  color: white;
  line-height: 21px;
  margin-bottom: 15px;
}


.casestudy-button {
  width: 100px;
  height: 23px;
  padding-top: 8px;
  background: #00FF0C;
  font-size: 12px;
  color: #222762;
  font-family: Oxanium-SemiBold;
  text-decoration: none;
}

@media (min-width: 640px) {

}

/* md: ≥ 768px - Tablets / landscape phones */
@media (min-width: 768px) {

}

/* lg: ≥ 1024px - Small laptops */
@media (min-width: 1024px) {
  .container {
    height: 550px;
    width: 420px;
    background-color: #070923;
    margin-bottom: 30px;
    margin-right: 30px;
  }

  .casestudy-img {
    width: 240px;
    height: 240px;
  }

  .casestudy-title {
    width: 400px;
    font-size: 30px;
    line-height: 40px;
  }

  .casestudy-text {
    width: 400px;
    font-size: 20px;
    color: white;
    line-height: 35px;
    margin-bottom: 45px;

  }

  .casestudy-button {
    width: 160px;
    height: 40px;
    padding-top: 15px;
    font-size: 20px;
  }
}

/* xl: ≥ 1280px - Desktops */
@media (min-width: 1280px) {

}

/* 2xl: ≥ 1536px - Large screens / 4K monitors */
@media (min-width: 1536px) {
  .container {
    height: 696px;
    width: 500px;
    background-color: #070923;
    margin-bottom: 30px;
    margin-right: 30px;
  }

  .casestudy-img {
    width: 266px;
    height: 266px;
  }

  .casestudy-title {
    width: 500px;
    height: 35px;
    font-size: 35px;
    line-height: 40px;
  }

  .casestudy-text {
    width: 425px;
    font-size: 24px;
    color: white;
    line-height: 35px;
  }

  .casestudy-button {
    width: 180px;
    height: 45px;
    padding-top: 15px;
    font-size: 24px;
  }
}
</style>